import { useMemo } from 'react';

import { useMondayContext } from '../contexts/monday-context';
import useFeatures from './use-features';

import { BILLING_BRAND_REMOVE } from '../constants/features';

export default function useCanFeatures() {
  const { canFeatureByTierOrGranted } = useFeatures();
  const { userData } = useMondayContext();
  const tier = userData.tier;
  const canRemoveDocumentBranding = useMemo(() => {
    return canFeatureByTierOrGranted(BILLING_BRAND_REMOVE, tier);
  }, [tier, canFeatureByTierOrGranted]);
  return { canRemoveDocumentBranding };
}
